import countapi from "countapi-js";
import React from "react";
import { Alert } from "react-bootstrap";

export default class ViewCount extends React.Component {
  constructor(props) {
    super(props);
    this.state = { count: 0 };
  }

  componentDidMount() {
    countapi.visits().then((result) => {
      this.setState({ count: result.value });
    });
  }

  render() {
    return (
      <Alert variant="info">
        <div className="text-center">
          This page has been requested: {this.state.count} times
        </div>
        <div className="text-center">
          <b>Sivakumar Kumar</b>
        </div>
        <div className="text-center">Software Developer - 🇮🇳 | 🇸🇪</div>
        <div className="text-center">
          <br />
          <h6>This site uses React Bootstrap UI Framework.</h6>
        </div>
      </Alert>
    );
  }
}
